<template>
    <article class="card-trail" :class="type">
        <NuxtLink class="image-wrapper" :to="`${url}${item.id}`" v-if="photo">
            <mess-image loading="lazy" :src="photo" :width="350" />
        </NuxtLink>

        <div class="content">
            <div class="copy">
                <NuxtLink :to="`${url}${item.id}`">
                    <h3 class="headline-2">{{ item.fields['Place Name'] }}</h3>
                </NuxtLink>
                <p v-if="item.fields['Points of Interest'] && item.fields['Points of Interest'].length > 0">{{ item.fields['Points of Interest'].length }} sites</p>
            </div>
        </div>
    </article>
</template>

<script setup>
    const { getImageFromArray } = useImageUrl();

    const props = defineProps({
        item: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: false,
            default: 'map',
        },
    });

    const { itinerary, item, type } = toRefs(props);

    const photo = computed(() => {
        if (item?.value?.fields?.['Photos']) {
            return getImageFromArray(item.value.fields['Photos'], 0);
        }
        return '';
    });

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/stops/';
        else return '/stops/';
    });
</script>

<style lang="scss" scoped>
    .card-trail {
        background-color: $white;
        .image-wrapper {
            display: block;
            position: relative;
        }

        img {
            position: absolute;
            inset: 0 0 0 0;
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }

        &.large {
            .image-wrapper {
                padding-top: 60%;
                height: 0;
                width: 100%;
            }
            .gray-tag {
                margin: 10px 0;
            }
            .content {
                padding: 10px 0;
                width: 100%;
            }
        }

        &.list,
        &.map {
            display: flex;
            .image-wrapper {
                width: 70px;
                height: 70px;
                flex-shrink: 0;
                margin-right: 17px;
            }
            h3 {
                margin-bottom: 10px;
            }
        }

        &.map {
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
            padding: 15px;
            .gray-tag {
                margin: 0 0 12px;
            }
            .footer {
                margin-top: 12px;
            }
        }

        &.list {
            padding: 20px 0;
            border-bottom: 1px solid #9d9fa2;
            .gray-tag {
                margin: 0 0 6px;
            }
            .content {
                display: flex;
                flex-grow: 1;
            }
            .footer {
                flex-grow: 0;
                flex-shrink: 0;
                margin: 0;
                flex-direction: column;
                button {
                    margin: 0;
                    + button {
                        margin-top: 18px;
                    }
                }
            }
            .copy {
                padding-right: 18px;
                flex-grow: 1;
            }
        }

        .footer {
            display: flex;
            margin-top: 10px;
            button {
                margin-right: 15px;
            }
        }

        .headline-3 {
            padding-right: 9%;
        }

        @media (min-width: $tablet) {
            flex-direction: column;
            height: 100%;

            &.list {
                border-bottom: none;
                padding: 5px 0;
            }

            &.list .image-wrapper {
                margin-bottom: 15px;
                margin-right: 0px;
                width: 100%;
                height: 195px;
            }
        }
    }
</style>
